import { render, staticRenderFns } from "./Groupusers.vue?vue&type=template&id=2e86378d&scoped=true&"
import script from "./Groupusers.vue?vue&type=script&lang=js&"
export * from "./Groupusers.vue?vue&type=script&lang=js&"
import style0 from "./Groupusers.vue?vue&type=style&index=0&id=2e86378d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e86378d",
  null
  
)

export default component.exports